export enum Categories {
  Topic = 'Topic',
  Media = 'Media',
}

export function getCategoryByKey(categoryStr: keyof typeof Categories): Categories {
  return Categories[categoryStr]
}
